export class Dictionary<T> {
	private items: { [key: string]: T } = {};

	public set(key: string, value: T): void {
		this.items[key] = value;
	}

	public get(key: string): T | undefined {
		return this.items[key];
	}

	public remove(key: string): void {
		delete this.items[key];
	}

	public getKeys(): string[] {
		return Object.keys(this.items);
	}

	public getValues(): T[] {
		return Object.values(this.items);
	}

	public hasKey(key: string): boolean {
		return key in this.items;
	}

	public size(): number {
		return Object.keys(this.items).length;
	}

	public clear(): void {
		this.items = {};
	}
}
